import { Component, OnInit, inject } from '@angular/core';
import { APIService } from 'app/services/api.service';
import { AuthenticationService } from 'app/services/auth.service';
import { LoaderService } from "app/services/loader.service";
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from "app/app.config";
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { AICFChartComponent } from '../../components/NWMCharts/aicfchart.component';
import { DatePipe } from '@angular/common';
import { PlaceholderPipe } from 'app/pipes/placeholder.pipe';

type apiTableInformationType = {
  Details: {
    TargetNameID: number;
    PeriodEnding: string;
    MarketValue: string;
    InvestedDuringYear: string;
    InvestedSinceInception: string;
    ProfitSinceInception: string;
    ReturnSinceInception: string;
    ReturnForYear: string;
    Currency: string;
  }[];
};

type apiDataType = {
  TableInformation: apiTableInformationType[];
};

@Component({
    templateUrl: './AICP-details.component.html',
    styleUrls: ['./AICP-details.component.scss'],
    imports: [MenuComponent, AICFChartComponent, DatePipe, PlaceholderPipe]
})

export class AICP_DetailsComponent implements OnInit {
  private api = inject(APIService);
  private auth = inject(AuthenticationService);
  private loaderService = inject(LoaderService);
  private route = inject(ActivatedRoute);
  private config = inject(AppConfig);

  public plan?: string;
  public data: apiTableInformationType[] = [];
  public valuationDate = '';
  public isPershing = false;

  ngOnInit() {
    this.loaderService.display(true, 'AICP-details');

    const reRg = this.auth.getCurrentReRg()!;

    this.isPershing = reRg.IsPershing;

    this.route.params.subscribe(params => this.plan = params['id'] ? params['id'] : '');

    this.valuationDate = this.auth.getCurrentValuationDate();
    const planPath = this.api.getPlanPath(this.plan || '', reRg.IsPershing);
    this.api.get<apiDataType>(`${this.config.portfolio.portfolioDetailsTotalAmountInvestedUrl}/${reRg.ReRgId}/${this.valuationDate}/${planPath}`).subscribe(
      data => {
        this.data = data.TableInformation;
        this.loaderService.display(false, 'AICP-details');
      },
      () => this.loaderService.display(false, 'AICP-details')
    );
  }

}